import { DialogTitle, Typography } from "@mui/material";
import React from "react";

import theme from "Theme/AppTheme";

interface TitleProps {
    align?: "left" | "center";
}

export function Title({
    align = "left",
    children,
}: React.PropsWithChildren<TitleProps>) {
    return (
        <DialogTitle
            sx={{
                opacity: 1,
                padding: "0 !important",
            }}
        >
            <Typography
                component="div"
                variant="h1"
                align={align}
                sx={{
                    fontFamily: theme.typography.fontFamily,
                    fontWeight: theme.typography.fontWeightSemibold,
                    fontSize: "20px",
                    lineHeight: "32px",
                    color: theme.palette.gray[700],
                }}
            >
                {children}
            </Typography>
        </DialogTitle>
    );
}
